import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get category
export const getCategory = createAsyncThunk("category/getCategory", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getCategory({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all category
export const getAllCategory = createAsyncThunk("category/getAllCategory", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllCategory();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("category/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("category/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("category/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageCategory({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create category
export const createCategory = createAsyncThunk("category/createCategory", async (data, { rejectWithValue }) => {
  const { name, parent, isActive } = data;
  try {
    const body = JSON.stringify({ name, parent, isActive });
    const { data } = await API.createCategory(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateCategory = createAsyncThunk("category/updateCategory", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, parent, isActive } = values;
  try {
    const body = JSON.stringify({ name, parent, isActive });
    const { data } = await API.updateCategory(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("category/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
